import { Base, Component, Ref, Watch } from '@/vue-property-decorator'
import { Bind, Debounce } from '@/utils/Decorator'
import { Button, Modal } from '@/plugins/ant-design-vue/tsx-support'
import { CommonCopy, CommonLoading } from '@/components/business-components'
import { CommonSwitchStatus, CurrencyEnum } from '@/api/common/type'
import { FinanceGetPayOrderDetailsData } from '@/api/finance/type'
import { FinanceShared } from '@/views/finance/shared'
import { GlobalManager } from '@/context'
import {
  OrderStatusEnum,
  PayModalConfigManager,
  RealNameSwitchEnum,
  RechargeIconType,
  RechargePaymentType,
  RmarkSwitchEnum,
  TransferCertificateSwitchEnum,
  UTRSwitchEnum
} from '../../config'
import { RootCategoryEnum } from '../../store/type'
import {
  apiFinanceGetPayOrderDetails,
  apiFinanceTransferCancel,
  apiFinanceTransferPayConfirm
} from '@/api/finance'
import { createSvgSprite } from '@/utils/business-utils/assets'
import {
  currencyFormatter,
  stringFormatSplit
} from '@/utils/business-utils/finance'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import BusinessUtils, { windowOpen } from '@/utils/business-utils'
import ComUploadComp, {
  UploadShape
} from '@/components/business-components/upload'
import Const from '@/context/const'
import CountDown from '@/layouts/components/countDown'
import FinanceUtils from '@/utils/business-utils/finance'
import PreIconInput from '@/components/business-components/preIcon-input'
import RealnameInput from '@/components/business-components/realname-input'
import Vue from 'vue'
// const comm_icon_hide = createSvgSprite('comm_icon_hide')
// const comm_icon_show = createSvgSprite('comm_icon_show')
// const icon_dl_bzbh = createSvgSprite('icon_dl_bzbh')
// const personIcon = createSvgSprite('icon_dl_person')
import { AxiosError } from 'axios'
import { urlFormatter } from '@/utils/Tool'
import AutoShrinkText from '@/components/auto-shrink-text'
import GlobalModal from '@/controller/Modal'
import saveAs from 'file-saver'
import style from './style.module.scss'
import to from 'await-to-js'
import useFinancePayStore from '../../store'
@Component<PayDetailsModalComp>({ name: 'PayDetailsModalComp' })
export default class PayDetailsModalComp extends Base {
  @Ref()
  private realNameInputRef!: HTMLDivElement
  @Ref()
  private UTRInputRef!: HTMLDivElement
  @Ref()
  private remarkInputRef!: HTMLDivElement
  @Ref()
  private transferCertificateRef!: HTMLDivElement

  store = useFinancePayStore()
  /**
   * loading
   */
  loading = false

  realName = ''

  /**
   * CPF账号
   */
  cpf = ''
  /**
   * 印度站UTR
   */
  utr = ''
  /**
   * 印度站Remark
   */
  remark = ''

  /**
   * 用户备注
   */
  userRemark = ''
  /**
   * 刮刮卡充值序列号是否展示
   */
  visibleCardPass = false

  // 是否显示充值倒计时
  hiddenCountDown = false

  /**
   * 转账充值凭证
   */
  transferCertificateData: {
    url?: string
    previewUrl: string
    file?: File
  } = {
    url: '',
    previewUrl: '',
    file: undefined
  }

  /**
   * 详情数据集合
   */
  detailsMap: {
    [orderNo: string]: {
      data: FinanceGetPayOrderDetailsData
      count: number
      timer?: number
    }
  } = {}

  axiosError: AxiosError | Error | null = null

  /**
   * 重置数据
   */
  resetData() {
    this.transferCertificateData = {
      url: '',
      previewUrl: '',
      file: undefined
    }
    this.utr = ''
    this.remark = ''
    this.userRemark = ''
    this.visibleCardPass = false
    this.hiddenCountDown = false
    this.loading = false
    this.axiosError = null
  }

  @Watch('store.visible')
  async orderNoListener(v: boolean) {
    if (!v) {
      this.resetData()
      GlobalModal.close('smartPayModal')
    }
    // if (n === o || !n) return
    // if (this.detailsMap[n]) {
    //   this.realName =
    //     this.detailsMap[n].data.orderName || this.store.validateForm.realName!
    //   return
    // }
    const n = this.store.orderNo!
    if (!n || !v) return
    this.loading = true

    const [err, data] = await to(apiFinanceGetPayOrderDetails({ order_no: n }))
    this.loading = false
    if (err) {
      this.axiosError = err
      return
    }
    this.axiosError = null
    this.$set(
      this.detailsMap,
      n,
      Vue.observable({
        data: data.data.data!,
        count: this.store.countdown
      })
    )
    this.hiddenCountDown = false
    this.realName =
      this.detailsMap[n].data.orderName || this.store.validateForm.realName!
    // 检查是否需要倒计时如果需要处理倒计时
    if (this.store.startCount && this.store.countdown !== 0) {
      this.store.startCount = false
      this.detailsMap[n].timer = setInterval(() => {
        this.detailsMap[n].count = this.detailsMap[n].count - 1
        if (this.detailsMap[n].count === 0) {
          clearInterval(this.detailsMap[n].timer)
          this.detailsMap[n].timer = undefined
        }
      }, 1000) as unknown as number
    }
  }

  beforeDestroy() {
    Object.values(this.detailsMap).forEach((item) => {
      if (item.timer) {
        clearTimeout(item.timer)
      }
    })
  }

  /**
   * 详情页面数据
   */
  get detailsData() {
    return this.detailsMap[this.store.orderNo ?? 'unknown']
  }
  /**
   * 是否为钱包
   */
  get isWallet() {
    return +this.detailsData.data?.payment_type === RechargePaymentType.WALLET
  }

  /**
   * 是否为刮刮卡
   */
  get isSIMCard() {
    return +this.detailsData.data?.payment_type === RechargePaymentType.SIM
  }

  /**
   * 是否有手续费
   */
  get isHasFee() {
    return !!this.detailsData.data.fee && this.detailsData.data.fee !== '0'
  }

  /**
   * 是否为在线充值[包含客服]
   */
  get isOnlinePay() {
    const validPayKinds = [
      RootCategoryEnum.ONLINE,
      RootCategoryEnum.UNKNOWN,
      RootCategoryEnum.ARTIFICIAL,
      RootCategoryEnum.SILVERMERCHANT
    ]
    return validPayKinds.includes(this.detailsData.data?.pay_kind)
  }

  /**
   * 是否为转账充值
   */
  get isTransfer() {
    return this.detailsData.data?.pay_kind === RootCategoryEnum.TRANSFER
  }

  get isSilverMerchant() {
    return this.detailsData.data?.pay_kind === RootCategoryEnum.SILVERMERCHANT
  }

  /**
   * 是否开启真实姓名输入框
   */
  get isShowRealNameInput() {
    return this.detailsData.data?.realNameSwitch !== CommonSwitchStatus.CLOSE
  }
  /**
   * 真实姓名输入框是否不可编辑
   */
  get isRealNameInputDisable() {
    return (
      this.detailsData.data?.realNameSwitch ===
      RealNameSwitchEnum.AUTOFILL_FREEZE
    )
  }

  get expireCountdown() {
    if (this.detailsData.data?.payOrderTimeOut) {
      return (
        this.detailsData.data?.payOrderTimeOut - Math.floor(Date.now() / 1000)
      )
    }

    return 0
  }

  /**
   * 是否开启UTR输入框
   */
  get isShowUTRInput() {
    return this.detailsData.data?.utrSwitch !== UTRSwitchEnum.CLOSE
  }
  /**
   * 是否是后4位
   */
  get isUTRLast4Input() {
    return (
      this.detailsData.data?.utrSwitch === UTRSwitchEnum.NOT_REQUIRED_LAST4 ||
      this.detailsData.data?.utrSwitch === UTRSwitchEnum.REQUIRED_LAST4
    )
  }
  /**
   * 是否是后6位
   */
  get isUTRLast6Input() {
    return (
      this.detailsData.data?.utrSwitch === UTRSwitchEnum.NOT_REQUIRED_LAST6 ||
      this.detailsData.data?.utrSwitch === UTRSwitchEnum.REQUIRED_LAST6
    )
  }
  /**
   * UTR输入框是否必填
   */
  get isUTRInputRequired() {
    return (
      this.detailsData.data?.utrSwitch === UTRSwitchEnum.REQUIRED ||
      this.detailsData.data?.utrSwitch === UTRSwitchEnum.REQUIRED_LAST4 ||
      this.detailsData.data?.utrSwitch === UTRSwitchEnum.REQUIRED_LAST6
    )
  }
  /**
   * 是否开启备注输入框
   */
  get isShowRemarkInput() {
    return (
      this.detailsData.data?.remarkSwitch !== RmarkSwitchEnum.CLOSE &&
      this.detailsData.data.status === OrderStatusEnum.WAIT
    )
  }
  /**
   * 备注输入框是否必填
   */
  get isRemarkInputRequired() {
    return this.detailsData.data?.remarkSwitch === RmarkSwitchEnum.REQUIRED
  }

  /**
   * 是否开启转账凭证上传功能
   */
  get isTransferCertificateOpen() {
    return (
      this.detailsData.data?.transferCertificateSwitch !==
      TransferCertificateSwitchEnum.CLOSE
    )
  }

  /**
   * 转账凭证是否必填
   */
  get isTransferCertificateRequired() {
    return (
      this.detailsData.data?.transferCertificateSwitch ===
      TransferCertificateSwitchEnum.VALID
    )
  }

  /**
   * 滚动到指定元素
   */
  scrollToView(ref: HTMLDivElement) {
    ref.scrollIntoView()
  }

  /**
   * 确认转账
   */
  async confirmTransfer() {
    const { t } = useI18n()

    // 处理真实姓名
    if (this.isShowRealNameInput && !this.realName) {
      GlobalManager.Modal.message({
        type: 'error',
        content: t('lobby.modal.pay.realNameRequired')
      })
      this.scrollToView(this.realNameInputRef)
      return
    }

    // 处理utr
    if (this.isShowUTRInput) {
      if (this.isUTRInputRequired) {
        this.scrollToView(this.UTRInputRef)
        if (this.isUTRLast4Input && this.utr.length !== 4) {
          GlobalManager.Modal.message({
            type: 'error',
            content: t('lobby.modal.pay.details.UTRToast', { num: 4 })
          })
          return
        }
        if (this.isUTRLast6Input && this.utr.length !== 6) {
          GlobalManager.Modal.message({
            type: 'error',
            content: t('lobby.modal.pay.details.UTRToast', { num: 6 })
          })
          return
        }
        if (!this.utr || this.utr.length < 4) {
          GlobalManager.Modal.message({
            type: 'error',
            content: t('lobby.modal.pay.details.UTRPlaceholder')
          })
          return
        }
      }
    }
    // 处理remark
    if (this.isShowRemarkInput && this.isRemarkInputRequired && !this.remark) {
      GlobalManager.Modal.message({
        type: 'error',
        content: t('lobby.modal.pay.details.transferRemkToast')
      })
      this.scrollToView(this.remarkInputRef)
      return
    }
    this.loading = true
    // 处理转账凭证
    if (this.isTransferCertificateOpen) {
      if (
        this.isTransferCertificateRequired &&
        !this.transferCertificateData.file
      ) {
        GlobalManager.Modal.message({
          type: 'error',
          content: t(
            'lobby.modal.pay.details.uploadTransferCertificateRequired'
          )
        })
        // 未上传提示中断逻辑，loading状态修改为false
        this.loading = false
        this.scrollToView(this.transferCertificateRef)
        return
      }
      if (this.transferCertificateData.file) {
        const url = await FinanceShared.uploadImage(
          this.transferCertificateData.file
        )
        // 上传异常
        if (!url) {
          //上传异常中断逻辑，loading状态修改为false
          this.loading = false
          return
        }
        this.transferCertificateData.url = url
      }
    }
    const [err] = await to(
      apiFinanceTransferPayConfirm({
        order_no: this.store.orderNo!,
        name: this.isShowRealNameInput ? this.realName : '',
        utrCode: this.utr,
        payRemark: this.remark,
        userRemark: this.userRemark,
        transferCertificate: this.transferCertificateData.url
      })
    )
    this.loading = false
    if (err) {
      // 订单超时返回充值弹窗
      setTimeout(() => {
        this.handleBackPay()
      }, 1000)
      return
    }

    this.store.isPaySuccess = true
    this.utr = ''
    this.remark = ''
    this.userRemark = ''
    this.$delete(this.detailsMap, this.store.orderNo!)
    await this.orderNoListener(true)
  }

  /**
   * 返回继续充值
   */
  handleBackPay() {
    this.store.visible = false
    this.store.orderNo = undefined
    GlobalModal.close('payRecordModal')
  }

  cancelOrderConfirm() {
    const { t } = useI18n()
    GlobalManager.Modal.create({
      title: t('lobby.common.tips.title'),
      class: style.orderConfirmModal,
      titlePosition: 'center',
      onOk: () => {
        this.cancelOrder()
      },
      cancelText: t('lobby.common.tips.cancel') as string,
      okText: t('lobby.common.tips.confirm') as string,
      content: () => (
        <div>
          <p>{t('lobby.modal.pay.details.cancelOrderContent1') as string}</p>
          <p>{t('lobby.modal.pay.details.cancelOrderContent2') as string}</p>
        </div>
      )
    })
  }

  @Bind
  @Debounce(800)
  saveImage(href: string) {
    const { t } = useI18n()
    // 给图片链接添加时间戳
    const url = urlFormatter(href, { _t: Date.now() })
    saveAs(url, `${t('lobby.modal.pay.details.qrCode')}.png`)

    GlobalManager.Modal.message({
      type: 'success',
      content: t('lobby.promote.promote.downloadSuccessTips')
    })

    // // 创建一个链接元素
    // const link = document.createElement('a')
    // link.href = href

    // // 设置下载的文件名 a标签改名会有浏览器限制，故采用saveAs
    // link.download = `${t('lobby.modal.pay.details.qrCode')}.png`
    // document.body.appendChild(link)
    // link.click()
    // // 删除链接元素
    // document.body.removeChild(link)
  }

  /**
   * 取消订单
   */
  @Bind
  @Debounce(800)
  async cancelOrder() {
    const no = this.store.orderNo ?? 'unknown'
    this.store.loading = true
    const [err, data] = await to(apiFinanceTransferCancel({ order_no: no }))
    if (err) {
      // 订单超时返回充值弹窗
      setTimeout(() => {
        this.handleBackPay()
      }, 1000)
      console.error('finance transfer cancel error:', err)
      return
    }
    if (data.data.data) {
      this.detailsMap[no ?? 'unknown'].data = data.data.data
    }

    // 触发表格查询保持数据一致性
    this.store.releaseTableQuery()
    this.store.loading = false
  }

  /**
   * 前往钱包
   */
  goToWallet(url: string) {
    windowOpen(url)
  }

  /**
   * 处理utr+
   */
  lockUTR(event: InputEvent) {
    const target = event.target as HTMLInputElement
    // 限制只能输入数字和英文大小写
    this.utr = target.value.replace(/[\W]/g, '')
  }
  /**
   * 混淆
   */
  doObfuscator(data: string) {
    const len = data.length
    return new Array(len).fill('*').join('')
  }

  /**
   * 切换刮刮卡是否隐藏序列号
   */
  changeCardPassVisible() {
    this.visibleCardPass = !this.visibleCardPass
  }

  /**
   * 状态区域
   */
  get renderStatusIconArea() {
    const { t } = useI18n()
    const details = this.detailsData.data ?? {}
    // 颜色
    const [s, st] = PayModalConfigManager.getColor(details?.status)

    // 状态图标
    const iconSource = PayModalConfigManager.getStatusIconByIconType(
      details?.status ?? 0
    )

    // 通道币种信息
    const channelCurrencyInfo = useMainStore().getCurrencyInfoByCode(
      details?.payCurrency
    )

    // 金额符号
    const channelCurrencySign = channelCurrencyInfo?.currencySign

    // 金额
    let channelAmount =
      details.payCurrency === 'VND'
        ? `${FinanceUtils.autoAddTwoZero(
            details?.channelAmount
          )}${channelCurrencySign}`
        : `${channelCurrencySign}${FinanceUtils.autoAddTwoZero(
            details?.channelAmount
          )}`
    // 虚拟币特殊处理
    if (channelCurrencyInfo?.currencyType === CurrencyEnum.CRYPTO) {
      channelAmount = `${FinanceUtils.formatExchange(
        details?.channelAmount?.toString()
      )}<span>${details?.payCurrency}</span>`
    }

    // 上分数量
    const realAmount = currencyFormatter(
      details?.amount ?? '',
      {
        symbol: ''
      },
      true
    )

    const renderExchangeArea = () => {
      const userCurrencyInfo = useMainStore().getCurrencyInfoByCode(
        details?.memberCurrency
      )
      // 订单会员币种是否和游戏汇率不一致
      const isUserCurrencyGameRateSpec = userCurrencyInfo?.gameRate !== 1
      // 订单会员币种与通道币种不一致,且汇率存在,且汇率不等于1
      const isUserCurrencyChannelCurrencySpec =
        details.payCurrency !== details.memberCurrency &&
        !!details.exchangeRate &&
        details.exchangeRate !== 1

      // 汇率字符串
      const currencyRateStr = details?.currencyRate
        ? `${t('lobby.modal.pay.rate')}  ${details?.currencyRate} ,`
        : null
      if (!isUserCurrencyGameRateSpec && isUserCurrencyChannelCurrencySpec) {
        // 币种游戏汇率一致,订单币种不一致
        return (
          <div class={style.exchangeArea}>
            {currencyRateStr} {t('lobby.modal.pay.title2')}
            <span>{`${userCurrencyInfo.currencySign}${realAmount}`}</span>
          </div>
        )
      } else if (
        isUserCurrencyGameRateSpec &&
        !isUserCurrencyChannelCurrencySpec
      ) {
        // 币种游戏汇率不一致,订单币种一致 [展示币种和游戏积分的汇率]
        return (
          <div class={style.gameRateExchangeArea}>
            <p>
              {FinanceUtils.getGameRateProportion(
                userCurrencyInfo?.currencySign ?? 'CNY',
                userCurrencyInfo?.gameRate
              )}
              , {t('lobby.modal.pay.title2')}
              <span>{realAmount}</span>
            </p>
          </div>
        )
      } else if (
        isUserCurrencyGameRateSpec &&
        isUserCurrencyChannelCurrencySpec
      ) {
        // 币种游戏汇率不一致,订单币种不一致 [展示币种和游戏积分的汇率,通道币种和用户币种的汇率]
        const isVND = details.memberCurrency === 'VND'
        return (
          <div class={style.gameRateExchangeArea}>
            <p>
              {currencyRateStr} ≈{isVND ? null : userCurrencyInfo?.currencySign}
              {FinanceUtils.formatMoney(
                FinanceUtils.times(
                  +details.channelAmount * details.exchangeRate
                ),
                details.memberCurrency
              )}
              {isVND ? userCurrencyInfo?.currencySign : null}
            </p>
            <p>
              {FinanceUtils.getGameRateProportion(
                userCurrencyInfo?.currencySign ?? 'CNY',
                userCurrencyInfo?.gameRate
              )}
              {','} {t('lobby.modal.pay.title2')}
              <span>{realAmount}</span>
            </p>
          </div>
        )
      }
    }

    const scale = (this.isWeb ? 70 : 110) / iconSource.width

    const showAmountCopy = [
      OrderStatusEnum.WAIT,
      OrderStatusEnum.CONFIRMED,
      OrderStatusEnum.NEED_TOW
    ].includes(details.status)
    return (
      <div class={style.top}>
        <div class={[style.statusIcon, s]}>
          <icon-sprite scale={scale} sprite={iconSource} />
        </div>
        <p class={[style.status, st]}>{details.status_name}</p>
        {this.expireCountdown > 0 &&
          !this.hiddenCountDown &&
          details.status === OrderStatusEnum.WAIT &&
          this.isTransfer && (
            <div class={style.countdownWrapper}>
              {t('lobby.modal.pay.details.countdownText1')}
              <p class={style.countdown}>
                <CountDown
                  onOver={() => {
                    this.hiddenCountDown = true
                  }}
                  hasTextBorder={false}
                  duration={this.expireCountdown}
                  showAllHours={true}
                />
                s
              </p>
              {t('lobby.modal.pay.details.countdownText2')}
            </div>
          )}
        <p class={[style.amount]}>
          <inner-html type={'span'} text={channelAmount}></inner-html>
          {showAmountCopy && (
            <CommonCopy class={style.copy} text={details.channelAmount} />
          )}
        </p>
        {/* 汇率 */}
        {renderExchangeArea()}
      </div>
    )
  }

  /**
   * 渲染手续费区域
   */
  get renderFeeArea() {
    const { t } = useI18n()

    const details = this.detailsData.data ?? {}
    if (!this.isOnlinePay || !this.isHasFee) {
      return
    }
    const realAmount = currencyFormatter(
      Number(details?.amount) - Number(details.realFee),
      {
        symbol: ''
      }
    )
    return (
      <ul
        class={[
          style.infoArea,
          this.isSIMCard ? style.dashBorder : style.dashBorderTop
        ]}
      >
        <li>
          <span>{t('lobby.modal.pay.feeRate')}</span>
          <span>{details.feeRate}</span>
        </li>

        <li>
          <span>{t('lobby.modal.pay.fee')}</span>
          <span>{currencyFormatter(details.fee)}</span>
        </li>

        <li>
          <span>{t('lobby.modal.pay.deduction')}</span>
          <span>{currencyFormatter(details.reduceFee)}</span>
        </li>
        <li>
          <span>{t('lobby.modal.pay.realFee')}</span>
          <span>{currencyFormatter(details.realFee)}</span>
        </li>
        <li class={style.bold}>
          <span>{t('lobby.modal.pay.realScore')}</span>
          <span>{currencyFormatter(realAmount)}</span>
        </li>
      </ul>
    )
  }

  /**
   * 渲染手续费费率区域
   */
  get renderSIMCardArea() {
    const { t } = useI18n()
    const details = this.detailsData.data ?? {}
    if (!this.isOnlinePay || !this.isSIMCard) {
      return
    }
    return [
      <ul class={[style.infoArea, style.dashBorder]}>
        <li>
          <span>{t('lobby.modal.pay.combination.cardNo')}</span>
          <span class={style.center}>
            {details.cardNumber}
            <CommonCopy class={style.copy} text={details.cardNumber ?? ''} />
          </span>
        </li>

        <li>
          <span
            onClick={this.changeCardPassVisible}
            class={{ [style.center]: true }}
          >
            {t('lobby.modal.pay.combination.cardPass')}

            {this.visibleCardPass ? (
              <icon-sprite
                class={[style.icon]}
                sprite={createSvgSprite('comm_icon_show')}
              />
            ) : (
              <icon-sprite
                class={[style.icon]}
                sprite={createSvgSprite('comm_icon_hide')}
              />
            )}
          </span>
          <span class={style.center}>
            {this.visibleCardPass
              ? details.cardPassword
              : this.doObfuscator(details.cardPassword)}
            <CommonCopy class={style.copy} text={details.cardPassword ?? ''} />
          </span>
        </li>
        <li>
          <span>{t('lobby.modal.pay.combination.networkMerch')}</span>
          <span class={style.center}>
            {details.networkMerch}
            <CommonCopy class={style.copy} text={details.networkMerch ?? ''} />
          </span>
        </li>
      </ul>,
      this.renderFeeArea
    ]
  }

  /**
   * 渲染在线充值区域
   */
  get renderOnlineArea() {
    const { t } = useI18n()
    const details = this.detailsData.data ?? {}

    if (!this.isOnlinePay) {
      return
    }
    return [
      <ul class={style.infoArea}>
        <li>
          <span>{t('lobby.modal.pay.details.transaction')}</span>
          <span>{details.order_type_name}</span>
        </li>

        <li>
          <span class={{ [style.center]: false }}>
            {t('lobby.modal.pay.details.method')}
          </span>
          <span class={{ [style.center]: false }}>{details.payment_name}</span>
        </li>
        <li>
          <span class={{ [style.center]: false }}>
            {t('lobby.modal.pay.details.channel')}
          </span>
          {!this.isSilverMerchant && (
            <span class={{ [style.center]: false }}>{details.bank_name}</span>
          )}
          {this.isSilverMerchant && (
            <span class={style.herf} onClick={this.goToBank}>
              {details.bank_name}
            </span>
          )}
        </li>
        <li>
          <span>{t('lobby.modal.pay.details.createTime')}</span>
          <span>{BusinessUtils.format(details.createtime)}</span>
        </li>
        {/* 在线充值完成状态交易时间 */}
        {details.status === OrderStatusEnum.SUCCESS && (
          <li>
            <span>{t('lobby.modal.pay.details.payedTime')}</span>
            <span>{BusinessUtils.format(details.payedtime)}</span>
          </li>
        )}
        <li>
          <span>{t('lobby.modal.pay.details.orderNo')}</span>
          <span class={style.center}>
            {details.order_no}
            <CommonCopy class={style.copy} text={details.order_no} />
          </span>
        </li>
        {details.walletName && (
          <li>
            <span>{t('lobby.modal.pay.details.tripartiteWallet')}</span>
            <span class={style.center}>
              <my-img
                src={details.walletLogo}
                class={style.mr20}
                width={36}
                height={36}
              />
              <span class={style.mr20}>{details.walletName}</span>
              <a href={details.walletDomain ?? '#'} target="_blank">
                {t('lobby.modal.pay.details.checkWallet')}
              </a>
            </span>
          </li>
        )}
        {details.frontRemark && (
          <li>
            <span class={style.alignSelfStart}>
              {t('lobby.modal.pay.details.frontRemark')}
            </span>
            <span class={style.center}>
              {details.frontRemark}
              <CommonCopy class={style.copy} text={details.frontRemark!} />
            </span>
          </li>
        )}
      </ul>,
      details.status === OrderStatusEnum.WAIT && this.isWallet && (
        <div class={style.btnArea3}>
          <div class={[Const.CssClassName.Lobby.Color.Red, style.text]}>
            {t('lobby.modal.pay.details.noWalletRemark')}
          </div>
          <Button.Tsx
            onClick={() => this.goToWallet(details.wallet_url)}
            type="finance"
            class={[style.btn]}
          >
            <p>{t('lobby.modal.pay.details.goToWallet')}</p>
          </Button.Tsx>
        </div>
      )
    ]
  }

  goToBank() {
    windowOpen(this.detailsData.data?.contactUrl)
  }

  /**
   * 单独渲染转账充值底部
   */
  renderTransferFooter() {
    const details = this.detailsData.data ?? {}

    if (!this.isTransfer) return
    const { t } = useI18n()
    return (
      details.status === OrderStatusEnum.WAIT && (
        <div class={style.btnArea}>
          <Button.Tsx
            onClick={this.cancelOrderConfirm}
            type="default"
            class={[style.btn2, style.btn]}
          >
            <p>{t('lobby.modal.pay.details.cancel')}</p>
          </Button.Tsx>
          <Button.Tsx
            // USDT不校验真实姓名
            disabled={!!this.detailsData.timer}
            onClick={this.confirmTransfer}
            type="primary"
            class={style.btn}
          >
            <p>{t('lobby.modal.pay.details.confirm')}</p>
            {this.detailsData.timer && (
              <p class={style.small}>
                (
                {t('lobby.modal.pay.details.confirmRemark', {
                  seconds: this.detailsData.count
                }) + ' '}
              </p>
            )}
          </Button.Tsx>
        </div>
      )
    )
  }

  /**
   * 渲染转账区域
   */
  get renderTransferArea() {
    const details = this.detailsData.data ?? {}
    if (!this.isTransfer) return
    const { t } = useI18n()
    // 是否为虚拟货币
    const isCrypto = details.templateType === CurrencyEnum.CRYPTO

    // 是否为PIX
    const isPIX = +details?.payicon === RechargeIconType.PIX

    // 是否为银行卡转账
    const isBank = +details?.payicon === RechargeIconType.YH

    // 银行卡图标
    const bankIconSource = PayModalConfigManager.getIconByRechargeIconType(
      +details?.payicon
    )

    // 虚拟币图标
    const cryptoIconSource =
      PayModalConfigManager.getIconByRechargeCurrencyCode(details?.payCurrency)

    // 图标
    const iconSource = isCrypto ? cryptoIconSource : bankIconSource

    const isZFBPayChannel = PayModalConfigManager.isZFBPayChannel(
      details.payment_id
    )

    // 后台配置图标
    const defaultIcon = (
      <my-img
        src={details.icon_url}
        class={style.mr20}
        width={36}
        height={36}
      />
    )

    const iconEl = details.icon_url ? (
      defaultIcon
    ) : (
      <icon-sprite
        class={style.mr20}
        sprite={iconSource}
        scale={36 / (iconSource.width ?? 36)}
      />
    )

    const isCNPJ = details.bank_code === 'CNPJ'
    const isCPF = details.bank_code === 'CPF'

    let bankCode = details.bank_no

    if (isPIX) {
      if (isCNPJ) {
        bankCode = stringFormatSplit(details.bank_no, '2.3.3/4-2')
      } else if (isCPF) {
        bankCode = stringFormatSplit(details.bank_no, '3.3.3-2')
      }
    }

    return [
      <ul class={style.infoArea}>
        {!isCrypto && (
          <li>
            <span>{t('lobby.modal.pay.details.name')}</span>
            <span class={style.center}>
              {details.bank_user}
              <CommonCopy class={style.copy} text={details.bank_user} />
            </span>
          </li>
        )}
        {/* PIX专用 */}
        {isPIX && details.extendValue && (
          <li>
            <span>
              {t(
                isCNPJ
                  ? 'lobby.modal.pay.details.cnpj'
                  : 'lobby.modal.pay.details.cpf'
              )}
            </span>
            <span class={style.center}>
              {isCNPJ
                ? stringFormatSplit(details.bank_addr, '2.3.3/4-2')
                : stringFormatSplit(details.extendValue, '3.3.3-2')}
              <CommonCopy class={style.copy} text={details.extendValue!} />
            </span>
          </li>
        )}
        {!isCrypto && (
          <li>
            <span>{t('lobby.modal.pay.details.no')}</span>
            <span class={style.center}>
              {bankCode}
              <CommonCopy class={style.copy} text={details.bank_no} />
            </span>
          </li>
        )}
        {/* PIX专用 */}
        {isPIX && (
          <li>
            <span>{t('lobby.modal.pay.details.accountType')}</span>
            <span class={style.center}>
              {details.bank_code}
              <CommonCopy class={style.copy} text={details.bank_code} />
            </span>
          </li>
        )}
        {!isCrypto && (
          <li>
            <span class={style.center}>
              {t('lobby.modal.pay.details.bankName')}
            </span>
            <span class={style.center}>
              {iconEl}
              {details.bank_name}
              <CommonCopy class={style.copy} text={details.bank_name} />
            </span>
          </li>
        )}
        {/* 中文站点,银行转账,配置开户银行 */}
        {isBank && details.extendName && details.extendValue && (
          <li>
            <span>{details.extendName}</span>
            <span>{details.extendValue}</span>
          </li>
        )}
        {/* 收款二维码 */}
        {!isCrypto && details.qrcode_url && (
          <li class={style.qrcodeWrapper}>
            <span>{t('lobby.modal.pay.details.qrCode')}</span>
            <div>
              <my-img
                class={style.qrcode}
                width={150}
                height={150}
                nativeOnClick={() => this.saveImage(details.qrcode_url)}
                src={details.qrcode_url}
              />
            </div>
            <div class={style.downloadWrapper}>
              <a
                class={style.downloadQrcode}
                onClick={() => {
                  this.saveImage(details.qrcode_url)
                }}
              >
                <AutoShrinkText
                  rowCount={2}
                  width={BusinessUtils.px2rem(120)}
                  limitHeight={BusinessUtils.px2rem(50)}
                  text={t('lobby.modal.pay.details.downloadQRCode') as string}
                ></AutoShrinkText>
              </a>
            </div>
          </li>
        )}
        <li>
          <span class={{ [style.center]: isCrypto }}>
            {t('lobby.modal.pay.details.method')}
          </span>
          <span class={{ [style.center]: isCrypto }}>
            {isCrypto && iconEl}
            {details.payment_name}
          </span>
        </li>
        {/* 虚拟币专用 */}
        {isCrypto && (
          <li>
            <span class={style.w330}>
              {t('lobby.modal.pay.details.usdtType')}
            </span>
            <span>{details.payCurrency}</span>
          </li>
        )}
        {isCrypto && (
          <li>
            <span class={style.w330}>{t('lobby.modal.pay.details.proto')}</span>
            <span>{details.cryptoProtocol}</span>
          </li>
        )}
        {isCrypto && (
          <li class={style.addrWrapper}>
            <span class={style.w270}>
              {t('lobby.modal.pay.details.address')}
            </span>
            <span class={[style.addr, style.center]}>
              {details.bank_no}
              <CommonCopy class={style.copy} text={details.bank_no} />
            </span>
          </li>
        )}
        {isCrypto && details.bank_no && details.qrcode_url && (
          <li class={style.qrcodeWrapper}>
            <span>{t('lobby.modal.pay.details.qrCode')}</span>
            <div>
              <my-img
                class={style.qrcode}
                width={184}
                height={184}
                nativeOnClick={() => this.saveImage(details.qrcode_url)}
                src={details.qrcode_url}
              />
            </div>
            <div class={style.downloadWrapper}>
              <a
                class={style.downloadQrcode}
                onClick={() => {
                  this.saveImage(details.qrcode_url)
                }}
              >
                {t('lobby.modal.pay.details.downloadQRCode')}
              </a>
            </div>
          </li>
        )}
        <li>
          <span>{t('lobby.modal.pay.details.createTime')}</span>
          <span>{BusinessUtils.format(details.createtime)}</span>
        </li>
        <li>
          <span>{t('lobby.modal.pay.details.orderNo')}</span>
          <span class={style.center}>
            {details.order_no}
            <CommonCopy class={style.copy} text={details.order_no} />
          </span>
        </li>
        {details.postscript && (
          <li>
            <span>{t('lobby.modal.pay.details.transferRemark')}</span>
            <span class={style.center}>
              {details.postscript}
              <CommonCopy class={style.copy} text={details.postscript} />
            </span>
          </li>
        )}
        {details.frontRemark && (
          <li>
            <span class={style.alignSelfStart}>
              {t('lobby.modal.pay.details.frontRemark')}
            </span>
            <span class={style.center}>
              {details.frontRemark}
              <CommonCopy class={style.copy} text={details.frontRemark!} />
            </span>
          </li>
        )}
        {details.transferCertificate && (
          <li class={style.transferCertificate}>
            <p>{t('lobby.modal.pay.details.transferCertificate')}</p>
            <img src={details.transferCertificate} />
          </li>
        )}
      </ul>,
      /* 转账专用信息 真实姓名输入框 */
      this.isShowRealNameInput && (
        <div class={style.confirmArea} ref="realNameInputRef">
          <p>
            <span class={style.mark2}>
              {t('lobby.modal.pay.realNameRemark')}
            </span>
          </p>
          <RealnameInput
            preIcon={createSvgSprite('input_icon_zsxm')}
            isRequire={true}
            class={style.input}
            allowClear={true}
            {...{
              attrs: {
                maxLength: 100
              }
            }}
            disabled={
              !!this.store.globalRealName && this.isRealNameInputDisable
            }
            v-model={this.realName}
            placeholder={t('lobby.modal.pay.details.placeHolder2') as string}
          />
        </div>
      ),
      /* 转账专用信息 UTR输入框 */
      this.isShowUTRInput && (
        <div class={style.confirmArea} ref="UTRInputRef">
          <p>
            <span class={style.mark2}>
              {this.isUTRLast4Input
                ? t('lobby.modal.pay.details.UTRRemarkLast4')
                : this.isUTRLast6Input
                ? t('lobby.modal.pay.details.UTRRemarkLast6')
                : t('lobby.modal.pay.details.UTRRemark')}
            </span>
          </p>
          <PreIconInput
            preIcon={createSvgSprite('input_icon_bzbh')}
            class={style.input}
            allowClear={true}
            maxLength={
              this.isUTRLast4Input ? 4 : this.isUTRLast6Input ? 6 : 100
            }
            isRequire={this.isUTRInputRequired}
            v-model={this.utr}
            onChange={this.lockUTR}
            placeholder={
              this.isUTRLast4Input
                ? (t('lobby.modal.pay.details.UTRPlaceholderLast4') as string)
                : this.isUTRLast6Input
                ? (t('lobby.modal.pay.details.UTRPlaceholderLast6') as string)
                : (t('lobby.modal.pay.details.UTRPlaceholder') as string)
            }
          />
        </div>
      ),
      this.isShowRemarkInput && (
        <div class={style.confirmArea} ref="remarkInputRef">
          <p>
            <span class={style.mark2}>
              {t('lobby.modal.pay.details.transferRemkTip')}
            </span>
          </p>
          <PreIconInput
            preIcon={createSvgSprite('icon_dl_bzbh')}
            class={style.input}
            isRequire={this.isRemarkInputRequired}
            allowClear={true}
            maxLength={100}
            v-model={this.remark}
            placeholder={
              t('lobby.modal.pay.details.transferRemkPlaceholder') as string
            }
          />
        </div>
      ),
      /* 转账专用信息 转账凭证上传 */
      this.isTransferCertificateOpen && (
        <div class={style.confirmArea} ref="transferCertificateRef">
          <p>
            <span>
              {t('lobby.modal.pay.details.uploadTransferCertificate')}
              {this.isTransferCertificateRequired && (
                <span class={style.required}>*</span>
              )}
            </span>
          </p>
          <my-img
            v-show={details.transferCertificate}
            src={details.transferCertificate}
            width={125}
            height={125}
          />
          <div class={style.upload}>
            <ComUploadComp
              onChange={async (data) => {
                const [file, previewUrl] = await FinanceShared.handleUpload(
                  data
                )
                if (!file || !previewUrl) return
                this.transferCertificateData.file = file
                this.transferCertificateData.previewUrl = previewUrl
              }}
              v-show={!details.transferCertificate}
              supportTypeList={['image/png', 'image/jpeg', 'image/jpg']}
              btnCenter={true}
              previewUrl={this.transferCertificateData.previewUrl}
              text={t('lobby.finance.withdraw.add.retry').toString()}
              uploadShape={
                this.transferCertificateData.previewUrl
                  ? UploadShape.BUTTON
                  : UploadShape.ICON
              }
            >
              <div class={style.remark} slot="btnText">
                <p>
                  {this.transferCertificateData.previewUrl
                    ? t(
                        'lobby.modal.pay.details.uploadTransferCertificateRemark4'
                      )
                    : t(
                        'lobby.modal.pay.details.uploadTransferCertificateRemark1'
                      )}
                </p>
                <p>
                  {t(
                    'lobby.modal.pay.details.uploadTransferCertificateRemark2'
                  )}
                </p>
                <p v-show={!this.transferCertificateData.previewUrl}>
                  {t(
                    'lobby.modal.pay.details.uploadTransferCertificateRemark3'
                  )}
                </p>
              </div>
            </ComUploadComp>
          </div>
        </div>
      ),
      /* 转账专用信息 支付宝-转账备注 */
      isZFBPayChannel && details.status === OrderStatusEnum.WAIT && (
        <div class={style.confirmArea}>
          <p>
            <span class={style.mark2}>
              {t('lobby.modal.pay.details.transferRemarkZFBPayTip')}
            </span>
          </p>
          <PreIconInput
            preIcon={createSvgSprite('input_icon_bzbh')}
            class={style.input}
            allowClear={true}
            maxLength={255}
            v-model={this.userRemark}
            placeholder={
              t(
                'lobby.modal.pay.details.transferRemarkZFBPayPlaceholder'
              ) as string
            }
          />
        </div>
      ),
      isCrypto && (
        <ul class={style.usdtRemarkArea}>
          <li>{t('lobby.modal.pay.details.usdtRemark1')}</li>
          <li>{t('lobby.modal.pay.details.usdtRemark2')}</li>
          <li>{t('lobby.modal.pay.details.usdtRemark3')}</li>
        </ul>
      ),

      /* 转账专用按钮 审核中 */
      (details.status === OrderStatusEnum.NEED_TODO ||
        details.status === OrderStatusEnum.NEED_TOW ||
        details.status === OrderStatusEnum.CONFIRMED) && (
        <div class={[style.btnArea, style.btnArea1]}>
          <Button.Tsx
            type="primary"
            onClick={this.handleBackPay}
            class={style.btn}
          >
            <p>{t('lobby.modal.pay.details.toPayBtn')}</p>
          </Button.Tsx>
        </div>
      )
    ]
  }

  get isWeb() {
    return useMainStore().isWeb
  }

  /**
   * 弹窗相关配置条件
   */
  get modalCondition() {
    const w = this.isWeb ? BusinessUtils.px2rem(600) : BusinessUtils.px2rem(710)

    return { w }
  }

  /**
   * 渲染详情弹窗
   */
  render() {
    const { t } = useI18n()
    const data = this.detailsMap[this.store.orderNo ?? 'unknown']
    const details = data?.data
    return (
      <div>
        {this.store.visible ? (
          <Modal.Tsx
            class={style.detailsModal}
            centered
            v-model={this.store.visible}
            maskClosable={false}
            destroyOnClose={true}
            footer={null}
            width={this.modalCondition.w}
            title={t('lobby.modal.pay.details.title') as string}
            afterClose={this.resetData}
          >
            <CommonLoading
              spinning={this.loading}
              class={style.loading}
              axiosError={this.axiosError}
              onRetry={() => {
                this.orderNoListener(true)
              }}
            >
              {details ? (
                [
                  <section class={style.orderDetails}>
                    {/* 状态 */}
                    {this.renderStatusIconArea}
                    {/* 刮刮卡 */}
                    {this.renderSIMCardArea}
                    {/* 在线充值信息 */}
                    {this.renderOnlineArea}
                    {/* 在线充值费率信息 */}
                    {!this.isSIMCard && this.renderFeeArea}
                    {/* 转账充值信息 */}
                    {this.renderTransferArea}
                  </section>,

                  this.renderTransferFooter()
                ]
              ) : (
                <section class={style.orderDetails}></section>
              )}
            </CommonLoading>
          </Modal.Tsx>
        ) : null}
      </div>
    )
  }
}
